<template>
  <div class="nav">
    <div class="nav-wrapper">
      <span v-show="back" class="back" @click="goBack"><i class="icon-back iconfont"></i></span>
      <span class="title">{{ title }}</span>
      <span class="btn-img close" v-if="close" @click="closeAcountAction"><span class="iconfont icon-zhuxiao"></span> <span>{{ $t('basic.close') }}</span></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navbar',
  props: ['title', 'back', 'close'],
  methods: {
    goBack: function () {
      this.$router.go(-1)
    },
    closeAcountAction: function () {
      this.$router.push('/closeAcount')
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.nav
  display none
  position fixed
  top 0px
  width 100%
  height 0.76rem
  line-height 0.76rem
  background-color #090909
  text-align center
  font-size 0.28rem
  color #ffffff
  z-index 99

  .nav-wrapper
    position relative

    .back
      position absolute
      display block
      height 0.49rem
      width 0.49rem
      top 0.14rem
      left 0.14rem
      color #ffffff
      line-height 0.49rem
      .iconfont
        color #fafafa !important
    .close
      position absolute
      display block
      height 0.49rem
      top 0.14rem
      right  0.14rem
      color #ffffff
      line-height 0.49rem
      font-size 0.12rem
      .iconfont
        color #fff !important
@media screen and (max-device-width: 720px), (max-width: 720px)
  .nav
    display block
</style>



// WEBPACK FOOTER //
// nav.vue?2081e119